import { RedirectLoginOptions } from '@auth0/auth0-react';
import { Location } from 'history';
import { jwtDecode } from 'jwt-decode';
import { DateTime } from 'luxon';

import { FORCE_LOGIN_PARAM } from './constants';

interface AnonAccessToken {
  access_token_v2: string;
  id_token: string;
  token_type: string;
}
export const getAnonToken = (): Promise<AnonAccessToken | undefined> =>
  fetch('/token/anon', {
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      }

      throw `Error fetching anonToken: ${res.status} (${res.statusText})`;
    })
    .catch(console.error);

export const getForceLoginOptions = (location: Location): RedirectLoginOptions | false => {
  const { pathname, search } = location;
  const params = new URLSearchParams(search);

  const forceLoginParamPresent = params.get(FORCE_LOGIN_PARAM) === 'true';

  if (forceLoginParamPresent) {
    params.delete(FORCE_LOGIN_PARAM);
    const paramString = params.toString();
    const nextSearchString = paramString.length > 0 ? `?${paramString}` : '';

    return {
      passwordless: true,
      appState: {
        returnTo: `${pathname}${nextSearchString}`,
      },
    };
  }

  return false;
};

export function shouldFetchToken(tokenStr: string | null): boolean {
  if (!tokenStr) {
    return true;
  }

  try {
    const decodedToken = jwtDecode(tokenStr);

    if (!decodedToken.iat) {
      return true;
    }

    const issuedAt = DateTime.fromMillis(decodedToken.iat * 1000);
    const diff = issuedAt.diffNow();

    return Math.abs(diff.as('minutes')) > 5;
  } catch (e) {
    console.error(e);

    return true;
  }
}
